import { Head, router } from '@inertiajs/react'
import AdminLayout from '../../components/layout/AdminLayout'
import Toggle from '../../components/ui/Toggle'

export default function NotificationPreferences({ preferences }) {
  const handleToggle = (type, enabled) => {
    router.patch('/notification_preferences', {
      preference_type: type,
      enabled: enabled
    })
  }

  const sections = [
    {
      title: 'Matches',
      icon: '🎯',
      items: [
        {
          key: 'match_created',
          label: 'Nouveau match créé',
          description: 'Notification quand un match est détecté entre un lead et une propriété'
        },
        {
          key: 'match_accepted',
          label: 'Match accepté',
          description: 'Notification quand un match est accepté par un partenaire'
        },
        {
          key: 'match_rejected',
          label: 'Match rejeté',
          description: 'Notification quand un match est rejeté par un partenaire'
        }
      ]
    },
    {
      title: 'Crédits',
      icon: '💰',
      items: [
        {
          key: 'credits_low',
          label: 'Crédits faibles',
          description: 'Alerte quand le seuil de crédits est atteint'
        }
      ]
    },
    {
      title: 'Collaboration',
      icon: '🤝',
      items: [
        {
          key: 'new_partner',
          label: 'Nouveau partenaire',
          description: 'Notification quand un partenaire est ajouté à votre réseau'
        },
        {
          key: 'partner_request',
          label: 'Demande de partenariat',
          description: 'Notification quand une agence souhaite collaborer avec vous'
        }
      ]
    }
  ]

  return (
    <AdminLayout>
      <Head title="Préférences de notifications" />

      <div className="max-w-3xl mx-auto space-y-6">
        {/* Header */}
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Préférences de notifications</h1>
          <p className="text-gray-600 mt-1">
            Gérez vos notifications par email pour rester informé des événements importants
          </p>
        </div>

        {/* Global toggle */}
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="text-2xl">📧</span>
                <h3 className="font-semibold text-gray-900">
                  Activer les notifications par email
                </h3>
              </div>
              <p className="text-sm text-gray-600 mt-1">
                Désactiver pour ne plus recevoir aucune notification email
              </p>
            </div>
            <Toggle
              checked={preferences.email_enabled}
              onChange={(checked) => handleToggle('email_enabled', checked)}
            />
          </div>
        </div>

        {/* Sections de préférences */}
        {preferences.email_enabled && (
          <>
            {sections.map((section) => (
              <div key={section.title} className="bg-white rounded-lg shadow">
                <div className="p-6 border-b border-gray-200">
                  <div className="flex items-center gap-2">
                    <span className="text-2xl">{section.icon}</span>
                    <h2 className="text-lg font-semibold text-gray-900">{section.title}</h2>
                  </div>
                </div>
                <div className="p-6">
                  <div className="space-y-4">
                    {section.items.map((item) => (
                      <div
                        key={item.key}
                        className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0"
                      >
                        <div className="flex-1 pr-4">
                          <h3 className="font-medium text-gray-900">{item.label}</h3>
                          <p className="text-sm text-gray-600 mt-1">{item.description}</p>
                        </div>
                        <Toggle
                          checked={preferences[item.key]}
                          onChange={(checked) => handleToggle(item.key, checked)}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </>
        )}

        {/* Info box */}
        {!preferences.email_enabled && (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <span className="text-2xl">⚠️</span>
              <div>
                <h3 className="font-semibold text-yellow-900">Notifications désactivées</h3>
                <p className="text-sm text-yellow-800 mt-1">
                  Vous ne recevrez aucune notification email. Vous pouvez manquer des événements importants.
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  )
}
